import listImage1 from "../../assets/1.1.svg";
import SeriesNavigation from "../../components/SeriesNavigation";
import { technology } from "../../data/navigationData";
import SEO from "../../components/SEO";
import ScrollDepthTracker from "../../components/ScrollDepthTracker";

export default function Candidate() {
  const candidateSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Candidate",
    "url": "https://www.thrombio.com.au/technology/candidate",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "MedicalEntity",
      "name": "TBO-309",
      "description": "TBO-309 is a novel antiplatelet compound currently in Phase II clinical trials for the treatment of acute ischemic stroke."
    }
  };

  return (
    <div className="bg-primary">
      <SEO
        title="Our Lead Candidate: TBO-309"
        description="Revolutionary drug development: TBO-309 represents an Australian drug development success story"
        keywords={['TBO-309', 'Antiplatelet', 'Thrombosis', 'PI3Kβ inhibitor', 'Blood Clotting', 'Drug Development']}
        ogImage="/tbo-309.jpeg"
        schema={candidateSchema}
      />
      <ScrollDepthTracker pageCategory="technology" pageName="candidate" />

      <div className="leadCandidateHeroBg">
        <div className="flex flex-col gap-[35px] px-[3.5rem] md:page-width pb-40 pt-[443px] relative md:pt-[520px] xl:pt-[409px] xl:pb-[155px] leadCandidateHeroBg2">
          {/* Optimized H1 tag that preserves layout */}
          <div className="font-bold text-[4.8rem] leading-[5.2rem] md:leading-[2.6rem] tracking-[1.92px] [text-shadow:_1px_2px_11px_rgb(0_0_0_/_0.89)] xl:text-[5rem] xl:leading-[2.6rem] xl:tracking-[.15rem]">
            <h1 className="sr-only">TBO-309: Leading Candidate for Stroke Treatment</h1>
            Our Lead Candidate:
          </div>
          <div className="font-syne font-bold text-[10.3rem] leading-[3.8rem] max-md:text-[#E0FFFF] tracking-[8.24px] md:tracking-[.584rem] [text-shadow:_1px_1px_5.5px_#000] md:text-[7.3rem] md:leading-[3.6rem] xl:text-[7.2rem] xl:leading-[3.6rem] xl:tracking-[.576rem]">
            TBO-
            <span className="max-md:mix-blend-difference">309</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-[30px] md:gap-[46px] xl:gap-[39px] px-12 md:px-20 xl:page-width">
        <div className="flex flex-col gap-12">
          <div className="text-[#E0FFFF] font-syne text-[2.5rem] leading-[4.1rem] tracking-[.125]md:text-[2.4rem] md:leading-[3.6rem] md:tracking-[.12rem] xl:text-[2.5rem]">
            PI3Kβ is a critical regulator of pathological blood clotting (thrombolysis)
          </div>
          <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem] md:text-[2rem] md:leading-[3.2rem] md:tracking-[.06rem] xl:text-[2.2rem] xl:leading-[3.4rem] xl:tracking-[.09rem]">
            TBO-309 represents an Australian drug development success story, that has resulted in a novel antiplatelet
            compound with truly remarkable properties. A key point of differentiation between TBO-309 and currently
            approved antiplatelets is its wide therapeutic window. When combined with existing anti-clotting therapies,
            it does not cause a major increase in bleeding. This has been confirmed in several proof-of-concept studies
            in both animal models and two Phase I human clinical trials. <br />
            <br />
            ThromBio's mission is to advance the global standard of care for the treatment of stroke using novel
            anti-thrombotic drugs with unprecedented safety and efficacy.
          </div>
        </div>
        <div className="flex flex-col gap-8">
          <div className="flex items-start gap-[28px]">
            {/* Updated alt tag */}
            <img src={listImage1} alt="List bullet point" className="mt-2" />
            <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
              Professor Jackson and his team discovered that PI3Kβ was a critical regulator of platelet function and
              thrombosis (Jackson et al, Nature Medicine, 2005).
            </div>
          </div>
          <div className="flex items-start gap-[28px]">
            {/* Updated alt tag */}
            <img src={listImage1} alt="List bullet point" className="mt-2" />
            <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
              Pharmacological inhibitors against PI3Kβ identified a critical role for this enzyme in promoting
              shear-dependent platelet activation (Nesbitt et al, Nature Medicine, 2009).
            </div>
          </div>
          <div className="flex items-start gap-[28px]">
            {/* Updated alt tag */}
            <img src={listImage1} alt="List bullet point" className="mt-2" />
            <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
              In a broad range of preclinical animal models, and in two Phase I human clinical trials (1-3), studies
              have demonstrated:
            </div>
          </div>
          <div className="flex items-start gap-[23px] md:gap-16 md:pl-20 xl:pl-32">
            <div className="rounded-full bg-[#61E4FF] size-6 mt-2 aspect-square"></div>
            <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
              that TBO-309 (AZD6482) can inhibit arterial thrombus formation in a dose-dependent manner, without causing
              a major increase in bleeding.
            </div>
          </div>
          <div className="flex items-start gap-[23px] md:gap-16 md:pl-20 xl:pl-32">
            <div className="rounded-full bg-[#61E4FF] size-6 mt-2 aspect-square"></div>
            <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
              that TBO-309 can be safely and effectively combined with other antithrombotic agents without causing a
              major increase in bleeding.
            </div>
          </div>
        </div>
      </div>
      <div className="pt-[150px] px-12 md:px-20 xl:page-width">
        {/* Optimized H2 tag that preserves layout */}
        <div className="text-[#B00000] font-syne text-[3rem] xl:text-[3.2rem] font-bold leading-[3.6rem] tracking-[.16rem] pb-[32px]">
          <h2 className="sr-only">Efficacy and Safety of TBO-309: Innovative Anti-Thrombotic Drug for Stroke Care</h2>
          Efficacy and Safety of TBO-309
        </div>
        <div className="text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
          Since its identification as an important antithrombotic target, inhibitors of PI3Kβ have been further
          characterised and developed. TBO-309 (aka AZD6482) has been taken through two Phase I clinical trials (Astra
          Zeneca), with reports demonstrating an excellent safety profile in healthy human male subjects (1,2). <br />{" "}
          <br />
          Additional Phase I studies have also demonstrated safety and eﬃcacy in combination with other antiplatelet and
          anticoagulant therapies (3).
        </div>
        <div className="grid xl:grid-cols-2 xl:pt-[62px] pb-[180px] md:pb-[150px]">
          <div className="flex justify-center xl:order-2">
            {/* Updated alt tag */}
            <img src="/8a713ae5fa5d3c5f194f0b22f2d087e9.jpeg" alt="Detailed scientific cartoon schematic published by ThromBio scientists showing signalling pathways leading to platelet activation" className="max-xl:py-20" />
          </div>
          <div className="flex flex-col gap-[32px]">
            <div className="flex flex-col gap-3">
              <a target="_blank" rel="noreferrer" href="https://doi.org/10.1111/j.1538-7836.2012.04912.x" className="text-[#61E4FF] text-[2.1rem] leading-[3.2rem] tracking-[.084rem] underline">
                Antithrombotic phosphoinositide 3-kinase β inhibitors in humans: a 'shear' delight!
              </a>
              <span className="text-[1.7rem] leading-[3.3rem] tracking-[.068rem]">
                doi.org/10.1111/j.1538-7836.2012.04912.x
              </span>
            </div>
            <div className="flex flex-col gap-3">
              <a target="_blank" rel="noreferrer" href='https://doi.org/10.1111/jth.13027' className="text-[#61E4FF] text-[2.1rem] leading-[3.2rem] tracking-[.084rem] underline">
                Exploration of efficacy and bleeding with combined phosphoinositide 3-kinase β inhibition and aspirin in
                man
              </a>
              <span className="text-[1.7rem] leading-[3.3rem] tracking-[.068rem]">
                doi.org/10.1111/jth.13027
              </span>
            </div>
            <div className="flex flex-col gap-3">
              <a target="_blank" rel="noreferrer" href="https://doi.org/10.1111/j.1538-7836.2012.04898.x" className="text-[#61E4FF] text-[2.1rem] leading-[3.2rem] tracking-[.084rem] underline">
                Human target validation of phosphoinositide 3-kinase (PI3K)β: effects on platelets and insulin
                sensitivity, using AZD6482 a novel PI3Kβ inhibitor
              </a>
              <span className="text-[1.7rem] leading-[3.3rem] tracking-[.068rem]">
                doi.org/10.1111/j.1538-7836.2012.04898.x</span>
            </div>
          </div>
        </div>
      </div>
                <SeriesNavigation 
                  items={technology} 
                  currentSlug="candidate" 
                  basePath="/technology" 
                />
    </div>
  );
}